import { Subject } from "rxjs";
import { GrupoDTO } from "@DTOS";
import { DatosCuotas } from "./DatosCuotas";

export class GrupoCuota {
    public actualizarDatosCuotas$ = new Subject<void>();
    public nombre = "";
    public grupo: GrupoDTO;
    public datosCuotas: DatosCuotas[] = [];

    public establecerDatosCuotas(datosCuotas: DatosCuotas[]) {
        if (datosCuotas == null) {
            return;
        }

        this.datosCuotas = datosCuotas;
        this.actualizarDatosCuotas$.next();
    }
}
